import { useEffect } from "react";
import useScrollAnimation from "../../hooks/useScrollAnimation";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import StatsBar from "./components/StatsBar";
import ServicesSection from "./components/ServicesSection";
import AboutSection from "./components/AboutSection";
import ProjectsSection from "./components/ProjectsSection";
import TestimonialsSection from "./components/TestimonialsSection";
import BrandsMarquee from "./components/BrandsMarquee";
import TrendSection from "./components/TrendSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

const HomePage = () => {
  useScrollAnimation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <StatsBar />
        <ServicesSection />
        <AboutSection />
        <ProjectsSection />
        <TestimonialsSection />
        <BrandsMarquee />
        <TrendSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;